export default function fixNumberDigits(value: number): number {
  const fixedNumber = value > 1 ? value.toFixed(1) : value.toPrecision(1);
  return Number(fixedNumber);
}
